import { render } from "./menuLogin.vue?vue&type=template&id=4a065970"
import script from "./menuLogin.vue?vue&type=script&lang=js"
export * from "./menuLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__